<footer class="govbook-footer">
	<div class="govbook-footer__pre-footer">
		<div class="govbook-container">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<ul class="menu menu--footer">
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/births-ceremonies-and-deaths"
								>Births, ceremonies and deaths</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/business"
								>Business</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/article/41736/Care-support-and-health"
								>Care. support and help</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/children"
								>Children and families</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/article/38130/Education-and-learning"
								>Education and learning</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/article/42615/Jobs-training-and-volunteering"
								>Jobs, training and volunteering</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/article/40080/Libraries-local-history-and-archives"
								>Libraries, local history and archives</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/article/42850/Out-and-about-in-Norfolk"
								>Out and about in Norfolk</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.norfolk.gov.uk/article/39617/Roads-and-transport"
								>Roads and transport</a
							>
						</li>
					</ul>
				</div>

				<div class="col-sm-12 col-md-6">

          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/article/38542/Rubbish-recycling-and-planning">Rubbish, recycling and planning</a>

            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/article/43659/Safety">Safety</a>

            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/article/38671/What-we-do-and-how-we-work">What we do and how we work</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/contactus">Contact Norfolk County Council</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/site-directory">Site map</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/websitedisclaimer">Website disclaimer</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/privacyandcookies">Website privacy notice</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.norfolk.gov.uk/article/39317/Privacy-settings-and-cookies">Privacy setting and cookies</a>
            </li>
            <li class="menu-item">
              <a target="_blank" aria-label="Accessibility statements (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statements</a>
            </li>
          </ul>
					<h4>Email us</h4>
					<a href="ceremonyenquiry@norfolk.gov.uk" class="footer-links"
						>ceremonyenquiry&#64;norfolk.gov.uk</a
					>
					<nav
						aria-labelledby="block-ecc-theme-gov-socialmedia-menu"
						id="block-ecc-theme-gov-socialmedia"
						class="block block-menu navigation navigation--social-media"
					>
						<h2
							class="visually-hidden"
							id="block-ecc-theme-gov-socialmedia-menu"
						>
							Social Media
						</h2>

						<ul
							class="menu menu--social-media justify-content-end justify-content-md-start mt-3"
						>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Facebook (opens in new window)"
									class="footer-links"
									href="https://www.facebook.com/Norfolkcc"
									class="social-link facebook"
									>Facebook</a
								>
							</li>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Youtube (opens in new window)"
									class="footer-links"
									href="https://www.youtube.com/user/NorfolkCountyCouncil"
									class="social-link youtube"
									>YouTube</a
								>
							</li>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Instagram (opens in new window)"
									class="footer-links"
									href="https://www.instagram.com/norfolkcc/#"
									class="social-link instagram"
									>YouTube</a
								>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>

	<div class="govbook-footer__footer">
		<div class="govbook-container">
			<div class="govbook-row">
				<div class="govbook-row__full">
					<div
						class="govbook-region govbook-region--footer region region-footer"
					>
						<div class="padding-horizontal">
							<div class="govbook-region__inner govbook-region__inner--footer">
								<div
									id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
									class="block block-localgov-core block-localgov-powered-by-block"
								>
									<span
										>Powered by
										<a
											target="_blank"
											aria-label="Bookinglab | GovBook (opens in new window)"
											class="footer-links"
											href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=ecc
                                            "
											>bookinglab | GovBook</a
										></span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
